import { useEffect } from 'react';

import { Keys } from '@components/types/keyboard';

type UseKeyPress = {
  enabled?: boolean;
  keys: Keys[];
  handler: () => void;
};

export const useKeyCombo = ({ keys = [], handler, enabled = true }: UseKeyPress) => {
  useEffect(() => {
    if (!enabled) return;

    const downHandler = (event: KeyboardEvent) => {
      const pressedKey = event.key?.toLowerCase();

      const wantsControl = keys.includes(Keys.Control);
      const wantsMeta = keys.includes(Keys.Meta);

      const hasControl = event.ctrlKey;
      const hasMeta = event.metaKey;
      const nonModifierKeys = keys.filter((key) => ![Keys.Control, Keys.Meta].includes(key));
      const nonModifierKeyMatch = nonModifierKeys.includes(pressedKey as Keys);
      const modifiersMatch = wantsControl === hasControl && wantsMeta === hasMeta;

      if (modifiersMatch && nonModifierKeyMatch) {
        event.preventDefault();
        handler();
      }
    };

    document.addEventListener('keydown', downHandler);

    return () => {
      document.removeEventListener('keydown', downHandler);
    };
  }, [keys, handler, enabled]);
};
